import {Brick, registerBrick, Service} from 'olympe';
import {USER_SERVICE_TOPICS} from '../../services/service_api/CreateUserService.brick';
import {finishUserServiceStartupSync, logSharedMemorySync} from '../../services/service_api/sharedMemorySync';

/**
 * Synchronize user-service state across backends. onlineFrontends stays local to each backend.
 */
export default class SynchronizeUserService extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Map<string, string[]>} frontendsCheckingAPR
     * @param {Map<string, {userId: string, userFullName: string}>} frontendIdUserLink
     * @param {string} uniqueID
     * @param {function()} forwardEvent
     */
    async update($, [frontendsCheckingAPR, frontendIdUserLink, uniqueID], [forwardEvent]) {
        const stores = {frontendsCheckingAPR, frontendIdUserLink};
        try {
            // Get data from a peer and apply it to this replica.
            // Ensure mutations happening during startup are replayed.
            const data = await Service.get('userService', {topic: USER_SERVICE_TOPICS.SYNCHRONIZE, initiator: uniqueID});
            if (!data || data.ignore) {
                finishUserServiceStartupSync(stores, {ignore: true});
                logSharedMemorySync('userService', {peerCount: 0, applied: 0});
            } else {
                const applied = finishUserServiceStartupSync(stores, data);
                logSharedMemorySync('userService', {peerCount: data.peerCount ?? 1, applied});
            }
        } catch (e) {
            // Continue startup when sync fails.
            finishUserServiceStartupSync(stores, {ignore: true});
            console.error('Error while synchronizing the user service:', e);
            logSharedMemorySync('userService', {peerCount: 0, applied: 0});
        }
        forwardEvent();
    }
}

registerBrick('019db993a727a755b4eb', SynchronizeUserService);
